<div mat-dialog-content>
	<form *ngIf="form"
		[formGroup]="form">
		<div class="bk-modal__left lot-form"
			*ngIf="f">
			<mat-form-field appearance="fill"
				class='mat-form-field--one-line mat-form-field--short'>
				<mat-label>
					{{'Lot Name' | translate }}
				</mat-label>
				<input matInput
					formControlName="Name"
					required
					type="text"
					(click)="showMap()">
				<mat-error *ngIf="f.Name.invalid && (f.Name.dirty || f.Name.touched)">
					{{'Lot name cannot be empty' | translate }}
				</mat-error>
			</mat-form-field>

			<div class="bk-flex-input-section">
				<mat-form-field appearance="fill"
					class='mat-form-field--one-line mat-form-field--short'>
					<mat-label>
						{{'Coordinates' | translate }}
					</mat-label>
					<input matInput
						id="lot-coords"
						type="text"
						formControlName="Coordinates"
						required
						(click)="showMap()">
					<mat-hint align="start">{{ 'coordinates format text' | translate }}
					</mat-hint>
					<mat-error *ngIf="f.Coordinates.invalid && (f.Coordinates.dirty || f.Coordinates.touched)">
						<span *ngIf="f.Coordinates.errors.coordinatesTooLong">
							{{'coordinates should contain 6 or less decimals' | translate }}
						</span>
						<span *ngIf="f.Coordinates.errors.coordinatesInvalid">
							{{'Invalid coordinates' | translate }}
						</span>
						<span *ngIf="f.Coordinates.errors.badLatLng">
							{{'Coordinates are outside the US Warning' | translate }}
						</span>
						<span *ngIf="f.Coordinates.errors.noSoilData">
							{{'There is no soil data available for this location. Please try different coordinates' | translate }}
						</span>
						<span *ngIf="f.Coordinates.errors.httpError">
							{{'SoilWeb service is not currently responding. Please try again later.' | translate }}
						</span>
					</mat-error>
				</mat-form-field>
				<button
					[disabled]="!editingSoilType"
					[class.bk-mat-input-icon-button--selected]="!editingSoilType"
					class="bk-mat-input-icon-button"
					(click)="showMap()">
					<i class="fa fa-map-marker bk-icon-button"
						matTooltip="see the map">
					</i>
				</button>
			</div>

			<div *ngIf="coordinateExplanation"
				class="bk-clearfix bk-location-warning">
				<i class="fa fa-warning"></i>
				{{ coordinateExplanation }}
			</div>

			<mat-form-field appearance="fill"
				class='mat-form-field--one-line mat-form-field--short'>
				<mat-label>
					{{'Size' | translate }}
				</mat-label>
				<input matInput
					formControlName="Acres"
					step="0.01"
					required
					type="number"
					(click)="showMap()">
				<span matSuffix class="mat-form-field-suffix--padded">
					{{'acres' | translate }}
				</span>
				<mat-error *ngIf="f.Acres.invalid && (f.Acres.dirty || f.Acres.touched)">
					<ng-container *ngIf="f.Acres.errors.required">
						{{ 'Field is required' | translate }}
					</ng-container>
					<ng-container *ngIf="f.Acres.errors.numberGreaterThan">
						{{ 'Acres must be greater than zero' | translate }}
					</ng-container>
					<ng-container *ngIf="f.Acres.errors.numberLessThan">
						{{'Acres must be less than 10,000' | translate }}
					</ng-container>
				</mat-error>
			</mat-form-field>

			<div *ngIf="!soilError"
				class="bk-flex-input-section">
				<div class="cm-ranchlot-dialog__soil-type-section">
					<span class="cm-ranchlot-dialog__soil-type-label">{{'Soil Type' | translate }}</span>
					<div class="cm-ranchlot-dialog__soil-type-name">{{ soilTypeName }}</div>
				</div>

				<button [disabled]="editingSoilType || soilError"
					[class.bk-mat-input-icon-button--selected]="editingSoilType"
					class="bk-mat-input-icon-button"
					(click)="showSoilProperties()">
					<i class="fa fa-ellipsis-v bk-icon-button"
						matTooltip="Edit soil properties">
					</i>
				</button>
			</div>
			<div *ngIf="f.ObstructionDepth.invalid"
				class="bk-invalid-text bk-invalid-text--padded">
				{{'Open soil settings to fix your obstruction depth' | translate }}
			</div>
		</div>

		<div class="bk-modal__right">
			<div [hidden]="editingSoilType"
				class="map-container bk-modal__triangle--left
				bk-modal__triangle--map">
				<div class="bk-modal__right-instructions">
					{{'Lot Map Instructions 1' | translate }}
				</div>
				<div class="bk-modal__right-instructions">
					<div class="bk-marker bk-marker--ranch">
						<svg-ranch-marker></svg-ranch-marker>
					</div>
					{{'Ranch Location' | translate }}
					<div class="bk-marker bk-marker--lot">
						<svg-lot-filled-marker></svg-lot-filled-marker>
					</div>
					{{'Lot Map Instructions 2' | translate }}
				</div>
				<div class="bk-modal__map-container">
					<agm-map (mapReady)="mapReady($event);"
						(mapClick)="mapClicked($event)"
						[mapTypeId]="'hybrid'"
						[fullscreenControl]="true">
						<agm-marker *ngFor="let marker of markers"
							[iconUrl]="'../assets/images/icons/map_marker-lot.png'"
							[latitude]="marker.lat"
							[longitude]="marker.lng">
						</agm-marker>
						<agm-marker *ngIf="ranchLocation"
							[iconUrl]="'../assets/images/icons/map_marker-ranch-v2.png'"
							[latitude]="ranchLocation.lat"
							[longitude]="ranchLocation.lng">
						</agm-marker>
						<map-control></map-control>
					</agm-map>
				</div>
			</div>

			<div [hidden]="!editingSoilType"
				class="soil-types-container bk-modal__triangle--left bk-modal__triangle--soil">
				<soil-properties-table *ngIf="soilPropertiesFormBuilder.form"
					[soilPropertiesFormBuilder]="soilPropertiesFormBuilder"
					[soilWebProperties]="soilPropertiesFormBuilder.soilWebProperties"
					[maxRootDepth]="f.ShouldUseObstructionDepth.value ?
						f.ObstructionDepth.value : null">
				</soil-properties-table>

				<div class="bk-modal__checkbox--obstruction-depth bk-clearfix" *ngIf="form">
					<input type="checkbox"
						formControlName="ShouldUseObstructionDepth"
						id="ShouldUseObstructionDepth"
						(change)="toggleObstructionDepth()"/>
					<div class="bk-modal__checkbox--label">
						<div>{{ 'Root Depth Obstruction' | translate }} <mat-icon matTooltip="{{ 'Root Depth Obstruction Help Text' | translate}}"
							class="bk-info-icon" >help_outline</mat-icon></div>
						<div class="bk-modal__checkbox--sub-label">({{ 'Root Depth Obstruction Details' | translate }})</div>
					</div>
				</div>

				<mat-form-field appearance="fill"
					*ngIf="f && f.ShouldUseObstructionDepth.value"
					class='mat-form-field--one-line mat-form-field--short'>
					<mat-label>
						{{'Depth' | translate }}
					</mat-label>
					<input matInput
						formControlName="ObstructionDepth"
						name="obstructionDepth"
						step="0.01"
						required
						type="number"/>
					<span matSuffix class="mat-form-field-suffix--padded">
						{{'ft' | translate }}
					</span>
					<mat-error *ngIf="f.ObstructionDepth.invalid &&
						(f.ObstructionDepth.dirty || f.ObstructionDepth.touched)">
						{{'Root Depth Obstruction must greater than 0 and less than 4' | translate }}
					</mat-error>
				</mat-form-field>
			</div>
		</div>
	</form>
</div>

<div mat-dialog-actions align="end">
	<button
		[ngClass]="isAssociatedWithPlanting ? 'bk-button bk-button--medium bk-button--text-only
		bk-button--float-left': 'bk-button__delete'"
		*ngIf="view === dialogViews.UPDATE && form && !isRanchCreateProcess"
		(click)="delete($event)"
		[disabled]="isAssociatedWithPlanting">
		{{'Remove Lot' | translate }}
		<i *ngIf="isAssociatedWithPlanting"
			matTooltip="{{'Cannot Delete Lot Warning' | translate }}"
			class="bk-recommendation__icon fa fa-info-circle">
		</i>
	</button>

	<button mat-button
		class="bk-button bk-button--medium bk-button--text-only
		bk-dialog__button--secondary"
		(click)="cancel()">
		{{'Cancel' | translate }}
	</button>
	<button mat-button [disabled]="isLotValid() === false"
		class="bk-button bk-button--medium"
		*ngIf="view === dialogViews.CREATE"
		(click)="submit()">
		{{'Add Lot' | translate }}
	</button>
	<button mat-button [disabled]="isLotValid() === false"
		class="bk-button bk-button--medium"
		*ngIf="view === dialogViews.UPDATE"
		(click)="submit()">
		{{'Save' | translate }}
	</button>
</div>
